import React, { useEffect } from "react";
import UserService from "../../utils/keycloak.service.js";
import LoadingIcon from "../custom/inputs/ERPSLoadingIcon.js";
import { ResponsiveBox } from "../primitives";
export default function LogoutPage(props) {
  useEffect(() => {
    const hasCodeRun = localStorage.getItem("codeHasRun");
    async function initKc() {
      if (hasCodeRun) {
        await UserService.initKeycloak(props);
      // await UserService.doLogout;
        localStorage.clear();
        UserService.doLogin();
      }
    }
    initKc();
  }, []);
  return (
    <ResponsiveBox textAlign={"center"} mt={30}>
      <LoadingIcon />
    </ResponsiveBox>
  );
}
